import { Toaster as SonnerToaster, toast } from 'sonner';

export interface ToasterProps {
  /** Position : bas-droite sur laptop, haut sur mobile (UX_ARCHITECTURE §7). */
  mobile?: boolean;
}

export function Toaster({ mobile = false }: ToasterProps) {
  return (
    <SonnerToaster
      position={mobile ? 'top-center' : 'bottom-right'}
      duration={5000}
      visibleToasts={3}
      closeButton
      toastOptions={{ classNames: { toast: 'toast' } }}
    />
  );
}

export { toast };
